// Lightweight service index — ONLY slug / name / shortName, for the shared shell
// (header dropdown, mobile nav, footer) that renders on every page. The full
// service copy lives in ./services.js and ships with the page chunks that need it.
//
// To add a service: append it to ./services.js AND to SERVICE_INDEX below. The
// production build fails (scripts/prerender-entry.jsx → assertDataIndexesInSync)
// and the dev server warns (./services.js) if the two ever disagree.

export const SERVICE_INDEX = [
  { slug: "emergency-plumbing", name: "Emergency Plumbing (24/7)", shortName: "Emergency Plumbing" },
  { slug: "drain-cleaning-sewer", name: "Drain Cleaning & Sewer Services", shortName: "Drain & Sewer" },
  { slug: "water-heaters", name: "Water Heater Installation & Repair", shortName: "Water Heaters" },
  { slug: "repiping-pipe-repair", name: "Repiping & Pipe Repair", shortName: "Repiping" },
  { slug: "fixture-installation", name: "Fixture Installation & Bathroom/Kitchen Plumbing", shortName: "Fixtures & Remodels" },
  { slug: "water-sewer-line-replacement", name: "Water & Sewer Line Replacement", shortName: "Water & Sewer Lines" },
  { slug: "gas-lines", name: "Gas Line Installation & Repair", shortName: "Gas Lines" },
  { slug: "commercial-new-construction", name: "New Construction & Commercial Plumbing", shortName: "Commercial" },
];
